import React from 'react';
import { Drawer } from 'antd';
import SidebarContent from '../Sidebar/SidebarContent';
import styles from './MobileDrawer.module.scss';
import logo from '../../logo.svg';

interface MobileDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  selectedKeys: string[];
  onMenuClick: ({ key }: { key: string }) => void;
}

const MobileDrawer: React.FC<MobileDrawerProps> = ({
  isOpen,
  onClose,
  selectedKeys,
  onMenuClick
}) => {
  return (
    <Drawer
      destroyOnClose
      closable={false}
      title={
        <div className={styles.drawerHeader}>
          <img src={logo} alt="logo" className={styles.logoImg} />
          <button
            type="button"
            aria-label="Close menu"
            className={styles.closeButton}
            onClick={onClose}
          >
            <img src="/layout.svg" alt="close" width={20} height={20} />
          </button>
        </div>
      }
      placement="left"
      onClose={onClose}
      open={isOpen}
      width={250}
      className={styles.mobileDrawer}
      styles={{
        body: { padding: 0 },
        header: { 
          padding: '16px 24px',
          borderBottom: '0.5px solid var(--app-divider-color)'
        }
      }}
    >
      <SidebarContent
        embedInDrawer
        selectedKeys={selectedKeys}
        onMenuClick={onMenuClick}
      />
    </Drawer>
  );
};

export default MobileDrawer; 